import { Component, ojs, app, payload } from "modular-openscriptjs";
import { either } from "../helpers";
import Card from "./Blocks/Card";
import CheckYesno from "./Blocks/CheckYesno";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

ojs(Card, CheckYesno);

export default class SettingItem extends Component {
	getLabel(setting) {
		if (setting?.type == "boolean") return setting?.label;
		if (setting?.type == "select") return setting?.label;
		return "";
	}

	getInputField(setting) {
		switch (setting?.type) {
			case "boolean": {
				return h.input(
					{
						class: "form-check-input",
						type: "checkbox",
						role: "switch",
						id: `settings-${setting.name}`,
						onclick: this.method("handle", ["${this}", setting]),
					},
					either(setting.value == true, { checked: true })
				);
			}
			case "select": {
				return h.select(
					{
						class: "form-select border-secondary-subtle",
						id: `settings-${setting.name}`,
						onchange: this.method("handle", ["${this}", setting]),
					},
					h.call(() => {
						let opts = [];
						for (let value in setting.accepted) {
							opts.push(
								h.option(
									{ value },
									setting.accepted[value],
									either(setting.value == value, {
										selected: true,
									})
								)
							);
						}

						return opts;
					})
				);
			}
		}
	}

	handle(elem, setting) {
		let path = `${setting.name}`;

		switch (setting.type) {
			case "boolean": {
				let value = 0;
				if (elem.checked) value = 1;

				path += `/${value}`;
				break;
			}
			case "select": {
				path += `/${elem.value}`;
			}
		}

		broker.send($e.setting.needs.update, payload({ path }));
	}

	render(setting, ...args) {
		switch (setting?.type) {
			case "boolean": {
				return h.Card(
					{
						class: "mb-3 shadow-sm border-0",
						body: [
							h.CheckYesno(
								{
									id: `settings-${setting.name}`,
									role: "switch",
									checked: setting?.value,
									label: {
										value: setting?.title,
										class: "fw-medium",
									},
									helpText: {
										value: setting.description,
										class: "text-muted small",
									},
									onchange: this.method("handle", [
										"${this}",
										setting,
									]),
								},
								{
									class: "check-yesno-end d-flex justify-content-between align-items-center w-100",
								}
							),
						],
					},
					...args
				);
			}
			case "select": {
				return h.Card(
					{
						title: setting?.title,
						class: "mb-3 shadow-sm border-0",
						body: [
							h.div(
								{ class: "d-flex flex-column gap-2" },
								h.label(
									{
										class: "form-label fw-medium",
										for: `settings-${setting.name}`,
									},
									this.getLabel(setting)
								),
								this.getInputField(setting),
								h.div(
									{ class: "form-text text-muted small" },
									setting.description
								)
							),
						],
					},
					...args
				);
			}
			default:
				return "";
		}
	}
}

ojs(SettingItem);
